import Vue from 'vue';
import StaffDeviceQRCode from "@/components/staff-device-qrcode/StaffDeviceQRCode.vue";
import Loader from '@/components/loader/Loader.vue';
import WebNotifications from '@/views/staff/web-notifications/WebNotifications.vue';
import { version } from "../package.json";
import { FacilitySettingsModel } from "@/models/FacilitySettings";
import PremiumFeaturesDialog from '@/components/premium/PremiumFeaturesDialog.vue';
import PremiumFeatureIcon from '@/components/premium/PremiumFeatureIcon.vue';
import {StaffAccessLevels} from "@/enums/StaffAccessLevels";

export default Vue.extend({
    name: 'App',
    components: {
        StaffDeviceQRCode,
        Loader,
        WebNotifications,
        PremiumFeaturesDialog,
        PremiumFeatureIcon,
    },
    data: () => ({
        drawer: null,
        dialog: false,
        tabletQrCode: false,
        loading: false,
        isStoppingImpersonation: false,
        isOpenedResidentsList: false,
        attrs: {
            boilerplate: false,
        },
        version: version,
        navigation: {
            width: 280,
            borderSize: 5,
            show: true
        },
        loadingRegirect: false
    }),
    provide() {
        return {
            isSidebarShow: this.navigation
        }
    },
    methods: {
        signOut() {
            this.$store.dispatch('userSignOut');
        },
        changeFacility(id) {
            this.loading = true;
            this.$store.dispatch('setIsChangingFacilityOnCurrentBrowser', true);
            this.$store.dispatch('changeCurrentUserFacility', { newFacilityId: id, redirectEnabled: true });
        },
        openNavItem(route, isEnabled = false) {
            if(!isEnabled){
                this.$refs.premiumFeaturesDialog.open();
            }
            else{
                if (this.$route.path !== route) {
                    this.$router.push(route);
                }
            }
        },
        checkNavItem(facilityAccessProperty) {

            if(facilityAccessProperty === 'isStaffHubCalendar' || facilityAccessProperty === 'isStaffHubPrintableCalendar'){
                if(!this.facilitySettingsModel?.isStaffHubCalendar && !this.facilitySettingsModel?.isStaffHubPrintableCalendar){
                    this.$refs.premiumFeaturesDialog.open();
                }
                return
            } 
            
            if(facilityAccessProperty === 'isStaffHubReporting' || facilityAccessProperty === 'isStaffHubSurveys'){
                if(!this.facilitySettingsModel?.isStaffHubReporting && !this.facilitySettingsModel?.isStaffHubSurveys){
                    this.$refs.premiumFeaturesDialog.open();
                }
                return
            } 
            
            if(facilityAccessProperty === 'isStaffHubContentManagerGallery'){
                if(!this.facilitySettingsModel?.isStaffHubContentManagerGallery 
                    && !this.facilitySettingsModel?.isStaffHubContentManagerDigitalSignage
                    && !this.facilitySettingsModel?.isStaffHubDevicesColumnDigitalSignage
                    && !this.facilitySettingsModel?.isStaffHubContentManagerMediaLibrary
                    && !this.facilitySettingsModel?.isStaffHubContentManagerMediaCreator
                    && !this.facilitySettingsModel?.isStaffHubDocuments){
                    this.$refs.premiumFeaturesDialog.open();
                }
                return
            }

            if(!this.facilitySettingsModel[facilityAccessProperty]){
                this.$refs.premiumFeaturesDialog.open();
                return
            }
        },
        toggleSidebar() {
            this.navigation.show = !this.navigation.show;

            if(this.navigation.show) {
                this.navigation.width = 280
            } else {
                this.navigation.width = 25
            }
        },
        showSidebar(data) {
            this.navigation.show = data;

            if(this.navigation.show) {
                this.navigation.width = 280
            } else {
                this.navigation.width = 25
            }
        },
        async stopImpersonation(){
            this.isStoppingImpersonation = true;
            await this.$store.dispatch('stopImpersonation');
            this.isStoppingImpersonation = false;
        },
        async getZendeskJWT() {
            this.loadingRegirect = true;

            await this.$store.dispatch('upsertUser');
            await this.$store.dispatch('getOrg');
            await this.$store.dispatch('mapUserToOrg');
            await this.$store.dispatch('getZendeskRedirectUrl')
            window.open(this.$store.state.zendeskModule.redirectUrl, '_blank', 'noopener, noreferrer');

            this.loadingRegirect = false;
        }
    },

    computed: {
        
        isAuthenticated() {
            return this.$store.getters.isAuthenticated;
        },
        isSuperAdmin() {
            return this.$store.getters.isSuperAdmin;
        },
        isImpersonationMode(){
            return this.$store.getters.isImpersonationMode;
        },
        facilitySettingsModel() {
            const facility: FacilitySettingsModel = this.$store.state.facilityModule.selectedFacility;

            return facility;
        },
        isAnonymous() {
            return this.$store.getters.isAnonymous;
        }, 
        isExternalPagesViewing() {
            return this.$store.getters.isExternalPagesViewing;
        },
        user() {
            return this.$store.state.authModule.user;
        },
        currentFacility() {
            return this.$store.state.authModule.currentFacility;
        },
        currentFacilityData() {
            return this.$store.state.authModule.currentFacilityData
        },
        isMaintenanceAdmin() {
            return this.user.accessLevel === StaffAccessLevels.MaintenanceAdmin;
        }
    },
    inject: {
        theme: {
            default: { isDark: false },
        },
    }
});